import React from "react";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { format } from "date-fns";
import reportConstants from "../constants";
import Events from "../../../../../utilities/EventEmitter";
import { utcToZonedTime } from "date-fns-tz";
import { withSnackbar } from "notistack";
import MESSAGES from "../../../../../appMessages";
import DriverPerformanceRenderer from "../components/ReportRenderer";
import { populateFormattedData, populateLinks } from "../util";
class DriverPerformanceRealtime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      isLoading: false,
      isDataRefreshed: false,
      formattedFilteredData: null,
    };
    this.pendingUpdateDriverIds = [];
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !==
      prevProps.userData.userProfile.terminal.id
    ) {
      this.getDriverPerformanceData();
    }
  }

  componentDidMount() {
    Events.on("RefreshDispatchStore", this.refreshReportData);
    Events.on("HandlePickupEvent", this.refreshReportData);
    Events.on("RefreshPickupsData", this.refreshReportData);
    Events.on("UpdateDriverRoute", this.updateDriverInfo);
    Events.on("UpdateDriverLoginStatus", (data) =>
      this.updateDriverInfo(JSON.parse(data).driverId)
    );
    this.getDriverPerformanceData();
  }

  componentWillUnmount() {
    Events.off("RefreshDispatchStore", this.refreshReportData);
    Events.off("HandlePickupEvent", this.refreshReportData);
    Events.off("RefreshPickupsData", this.refreshReportData);
    Events.off("UpdateDriverRoute", this.updateDriverInfo);
    Events.off("UpdateDriverLoginStatus", (data) =>
      this.updateDriverInfo(JSON.parse(data).driverId)
    );
  }

  refreshReportData = () => {
    this.getDriverPerformanceData(true);
  };

  getTerminalDateTime = () => {
    return utcToZonedTime(
      new Date(),
      this.props.userData.userProfile.terminal.offset
    );
  };

  getCurrentDispatchDate = () => {
    return format(this.getTerminalDateTime(), reportConstants.APP_DATE_FORMAT);
  };

  updateDriverInfo = (driverId) => {
    const driverIdList = Array.isArray(driverId)
      ? driverId.map((d) => d.toUpperCase())
      : [driverId.toUpperCase()];
    this.pendingUpdateDriverIds.push(...driverIdList);
    const driversToUpdate = [
      ...new Set([...this.pendingUpdateDriverIds]),
    ].slice();
    this.pendingUpdateDriverIds = [];
    const { userData } = this.props;
    // fetch Data for pending driverIds List
    getDataWithQueryString(
      "DriverPerformance",
      `terminalCode=${
        userData.userProfile.terminal.code
      }&dispatchDate=${this.getCurrentDispatchDate()}&driverIds=${driversToUpdate.join(
        ","
      )}`
    )
      .then(({ data: driversData, status }) => {
        if (status === 200 && driversData) {
          this.updateDriverDataByDriverIds(driversData, driversToUpdate);
        } else {
          // if data fetch failed , restore pending list to update in next call
          this.pendingUpdateDriverIds = [
            ...this.pendingUpdateDriverIds,
            ...driversToUpdate,
          ];
        }
      })
      .catch(() => {
        this.pendingUpdateDriverIds = [
          ...this.pendingUpdateDriverIds,
          ...driversToUpdate,
        ];
      });
  };

  handleError = () => {
    this.props.enqueueSnackbar(MESSAGES.DRIVER_PERFORMANCE.FETCH_DATA_FAILURE, {
      variant: "error",
    });
    this.setState({
      isLoading: false,
      data: null,
    });
  };

  getDriverPerformanceData = (isDataRefreshed = false) => {
    const { userData } = this.props;
    !isDataRefreshed && this.setState({ isLoading: true, data: null });
    getDataWithQueryString(
      "DriverPerformance",
      `terminalCode=${
        userData.userProfile.terminal.code
      }&dispatchDate=${this.getCurrentDispatchDate()}`
    ).then(
      ({ status, data }) => {
        if (status && status >= 200 && status <= 400) {
          this.initializeReportData(data, isDataRefreshed);
        } else {
          this.handleError();
        }
      },
      () => {
        this.handleError();
      }
    );
  };

  updateDriverDataByDriverIds = (driversData, driverIdList) => {
    const data = [...this.state.data];
    driverIdList.map((driverId) => {
      const indexToUpdate = data.findIndex(
        (driverData) => driverData.driverId === driverId
      );
      const updatedDriverData = driversData.find(
        (driverData) => driverData.driverId === driverId
      );
      data[indexToUpdate] = { ...updatedDriverData };
    });
    this.initializeReportData(data, true);
  };

  getFormattedReportData = (data) => {
    const formattedData = populateFormattedData(
      data,
      this.getCurrentDispatchDate(),
      true
    );
    const links = populateLinks(formattedData);
    return {
      tasks: formattedData,
      links: links,
    };
  };

  initializeReportData = (responseData, isDataRefreshed) => {
    const data = responseData ? responseData : null;
    this.setState({
      data,
      formattedFilteredData: data ? this.getFormattedReportData(data) : null,
      isDataRefreshed,
      isLoading: false,
    });
  };

  updateFilteredData = (filteredData) => {
    this.setState({
      formattedFilteredData: this.getFormattedReportData(filteredData),
      isDataRefreshed: false,
    });
  };

  render() {
    const { isDataRefreshed, isLoading, data, formattedFilteredData } =
      this.state;
    return (
      <React.Fragment>
        <DriverPerformanceRenderer
          isLoading={isLoading}
          data={data}
          isDataRefreshed={isDataRefreshed}
          currentDispatchDate={this.getCurrentDispatchDate()}
          isRealtimeReport
          updateFilteredData={this.updateFilteredData}
          formattedFilteredData={formattedFilteredData}
          showBackButton={false}
        />
      </React.Fragment>
    );
  }
}
export default compose(
  withUserProfile,
  withSnackbar
)(DriverPerformanceRealtime);
